<div class="section" linPerfectScrollbar>
  <div class="header">
    <div class="title-container" [class.multiline-title-container]="multiline">
      <span class="h1">{{ title }}</span>

      <ng-template #content> <ng-content select="lin-layout-section-meta"></ng-content> </ng-template>
      @if (multiline) {
      <div class="multiline-content">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
      } @else {
      <ng-container *ngTemplateOutlet="content"></ng-container>
      }
    </div>

    <ng-content select="lin-layout-section-toolbar"></ng-content>
  </div>

  <div class="content" [class.content-scrollable]="scrollable">
    <ng-content></ng-content>
  </div>
</div>
